module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"socialMediaActive":"The social media is active","socialMediaNoActive":"The social media is not active","edit":"Edit social media","delete":"Delete social media"},"es":{"socialMediaActive":"La red social está activa","socialMediaNoActive":"La red social no está activa","edit":"Editar la red social","delete":"Eliminar la red social"}}')
  delete Component.options._Ctor
}
